export const INITIAL_PROMPT_STORAGE_KEY_PREFIX = 'initial_prompt_';

/** Activity's Live / Draft filter in the URL. Live is the default, so only `draft` is written. */
export const AUTOMATION_RUN_STAGE_PARAM = 'runStage';
